import { Preloader } from "../Preloader";
import { EntityModalForm } from "../../CRUDs/abstracts/mixins/EntityModalForm";
import { CardConfirmed } from "../Events/Events";
import masks from "../../masks";


export class CardForm {

    constructor(card, type) {
        this.form = document.querySelector('#form-container');
        this.preloader = new Preloader(`${type}-${card.entityClass}-modal`, true);
        this.card = card;
        this.listners();
        masks.expdate();
    }

    validate() {
        const validSet = new Set([
            this.validateExpirationDate(this.form.querySelector('input[name=expiration_date')),
        ]);
        const validValue = Array.from(validSet).indexOf(false) == -1;
        return validValue;
    }

    submit(type) {
        if (type == 'create') {
            return () => {
                if (this.validate()) {
                    this.preloader.setMessage('Processing');
                    this.preloader.open();
                    this.card.create(this.successCallback, this.errorCallback);
                }
            }
        } else if (type == 'edit') {
            return () => {
                if (this.validate()) {
                    this.card.update(this.successCallback, this.errorCallback);
                }
            }
        } else if (type == 'confirm-card') {
            return () => {
                if (this.validate()) {
                    this.card.confirmCardData(this.confirmationSuccessCallback, this.errorCallback);
                }
            }
        }
    }

    successCallback(result) {
        const formHTML = result.modal;
        EntityModalForm.pasteForm(formHTML);
        $('.modal-backdrop').first().remove();
        $('#success-action-modal').modal('show');
        document.dispatchEvent(CardConfirmed);
    }

    errorCallback(result) {
        EntityModalForm.pasteForm(result.modal);
        $('.modal-backdrop').first().remove();
        $('#failed-action-modal').modal('show');
    }

    confirmationSuccessCallback(result) {
        if (result.modal) {
            EntityModalForm.pasteForm(result.modal);
            $('.modal-backdrop').first().remove();
            $('#success-action-modal').modal('show');
        }
        document.dispatchEvent(CardConfirmed);
    }

    listners() {
        $(this.form).find('button#create').off();
        $(this.form).find('button#edit').off();
        $(this.form).find('button#confirm-card').off();
        $(this.form).find('button#create').on('click', this.submit('create'));
        $(this.form).find('button#edit').on('click', this.submit('edit'));
        $(this.form).find('button#confirm-card').on('click', this.submit('confirm-card'));
    }

    validCallback(input, valid, message) {
        const messageContainer = document.querySelector('#validation-message');
        if (!valid) {
            input.style.borderColor = 'red';
            messageContainer.querySelector(`#${message.fieldName}`)?.remove();
            messageContainer.innerHTML += `<div id="${message.fieldName}" class="mt-2 valid-message unvisible">${humanizedName(message.fieldName)}: ${message.text}</div>`;
            const validMessage = messageContainer.querySelector(`#${message.fieldName}.valid-message`);
            validMessage.classList.remove('unvisible');
        }
        else {
            input.style.borderColor = 'black';
            const validMessage = messageContainer.querySelector(`#${message.fieldName}.valid-message`);
            if (validMessage) {
                validMessage.remove();
            }
        }
    }

    validateExpirationDate(input){
        const dateString = input.value;
        const [month, year] = dateString.split('/');
        const monthValid = month > 0 && month <= 12;
        const nowYear = new Date().getFullYear() % 2000;
        const yearValid = year >= nowYear;
        const dateNotExpired = new Date(`20${year}-${month}-01`) >= new Date();
        const valid = monthValid && yearValid && dateNotExpired;
        let message = '';
        if (!input.value) message = 'field is empty';
        else if (!monthValid | !yearValid) message = 'Incorrect format';
        else if(!dateNotExpired) message = 'date is already expired';
        this.validCallback(input, valid, {fieldName: 'expiration_date', text: message});
        return valid;
    }
}

